import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getParsersKeywordsPositionLimits } from "root/api/parsers/keywords-position/limits";
import { geoCities } from "root/utils/globalVariables";

const initialState = {
  params: {
    runName: "",
    cityId: geoCities[0].id,
    productId: null,
    keywordsList: [],
  },
  reports: {
    data: [],
    checkedItems: [],
  },
  limits: {
    isLoading: false,
    maxUsage: null,
    existUsage: null,
  },
};
//
export const fetchProductPositionsLimits = createAsyncThunk(
  "/getParsersKeywordsPositionLimits",
  async (_, thunkAPI) => {
    try {
      const response = await getParsersKeywordsPositionLimits();
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue("Error");
    }
  }
);
//
const productPositionSlice = createSlice({
  name: "productPosition",
  initialState,
  reducers: {
    setProductPositionsParamsByName(state, { payload: { name, value } }) {
      state.params[name] = value;
    },
    setProductPositionsReportsData(state, { payload: value }) {
      state.reports.data = value;
    },
    setProductPositionsReportsCheckedItems(state, { payload: value }) {
      state.reports.checkedItems = value;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchProductPositionsLimits.pending, state => {
      state.limits.isLoading = true;
    });
    builder.addCase(fetchProductPositionsLimits.fulfilled, (state, { payload }) => {
      state.limits.isLoading = false;
      state.limits.maxUsage = payload.max_usage_count;
      state.limits.existUsage = payload.exists_usage_count;
    });
    builder.addCase(fetchProductPositionsLimits.rejected, state => {
      state.limits.isLoading = false;
    });
  },
});

export default productPositionSlice.reducer;
export const {
  setProductPositionsParamsByName,
  setProductPositionsReportsData,
  setProductPositionsReportsCheckedItems,
} = productPositionSlice.actions;
